import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PendingRequestService {
  private numberOfPendingRequestsSource = new BehaviorSubject<number>(0);

  numberOfPendingRequests$ = this.numberOfPendingRequestsSource.asObservable();

  publishNumberOfPendingRequests$(numberOfPendingRequests: number) {
    this.numberOfPendingRequestsSource.next(numberOfPendingRequests);
  }
}
